import React from "react";
import { connect } from "react-redux";
import ReactEcharts from "echarts-for-react";
import axios from "axios";
import { Dropdown } from "react-bootstrap";
import ReferralsCard from "../../components/Dashboard/ReferralsCard";
import ReferralsCard1 from "../../components/Dashboard/ReferralsCards1";
import PageHeader from "../../components/PageHeader";
import SparkleCard from "../../components/SparkleCard";
import LogoiCON from "../../assets/images/logo-icon.svg";
import { getTopRevenueOption } from '../../Data/DashbordData';
import {
  saleGaugeOption,
  sparkleCardData,
} from "../../Data/DashbordData";
import {
  toggleMenuArrow,
  loadSparcleCard,
} from "../../actions";
import ReferralsCards1 from "../../components/Dashboard/ReferralsCards1";

class Dashbord extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardData: [],
      deliveredOrders: [],
   
      topRevenueOption: {},
    };
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    this.loadDataCard();
    // await this.fetchOrders(); // Fetch order data and calculate sales
  }

  async loadDataCard() {
    const { cardData } = this.state;
    const allCardData = cardData;
    cardData.forEach((data, i) => {
      const uData = [];
      data.sparklineData.data.forEach((d, j) => {
        uData[j] = Math.floor(Math.random() * 10) + 1;
      });
      allCardData[i].sparklineData.data = [...uData];
    });
    this.setState({ cardData: [...allCardData] });
  }

  // async fetchOrders() {
  //   try {
  //     const token = localStorage.getItem("token");
  //     const response = await axios.get(
  //       "https://dropdose-backend.onrender.com/api/wholseller/oders",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     const users = response.data.users;
  //     const allOrders = users.flatMap((user) => user.orders);
  //     const deliveredOrders = allOrders.filter(
  //       (order) => order.status.toLowerCase() === "deliverd" // Correct the spelling
  //     );

  //     // Calculate total sales based on final_price
  //     const totalSales = deliveredOrders.reduce(
  //       (acc, order) => acc + order.final_price, // Use final_price instead of order.amount
  //       0
  //     );

  //     // Set the deliveredOrders and totalSales to the state
  //     this.setState({
  //       deliveredOrders,
  //       totalSales,
  //     });
  //   } catch (error) {
  //     console.error("Error fetching orders:", error);
  //   }
  // }





  render() {
    const { loadingPage } = this.props;
    const { cardData, deliveredOrders } = this.state;

    if (loadingPage) {
      return (
        <div className="page-loader-wrapper">
          <div className="loader">
            <div className="m-t-30">
              <img src={LogoiCON} width="48" height="48" alt="Lucid" />
            </div>
            <p>Please wait...</p>
          </div>
        </div>
      );
    }
    const topRevenueOption = getTopRevenueOption(deliveredOrders); // Generate options based on current deliveredOrders
    return (
      <div onClick={() => document.body.classList.remove("offcanvas-active")}>
        <div className="container-fluid">
          <PageHeader HeaderText="Dashboard" Breadcrumb={[{ name: "Dashboard" }]} />

          <div className="row">
  {sparkleCardData.map((data, i) => (
    <div className="col-md-6 col-6" key={data.heading}>
      <SparkleCard
        index={i}
        heading={data.heading}
        perText={data.perText}
        isRandomUpdate={true}
        apiUrl={data.apiUrl}
        mainData={Array.isArray(data.sparklineData.data) ? data.sparklineData.data : []}
        chartColor={data.sparklineData.areaStyle.color}
        sparklineData={data.sparklineData}
      />
    </div>
  ))}
</div>


          {/* <div className="row clearfix">
  <div className="col-lg-6 col-md-6">
    <ReferralsCard />
  </div>

  <div className="col-lg-6 col-md-6">
    <ReferralsCard1 />
  </div>
</div> */}

        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  loginReducer,
  navigationReducer,
  analyticalReducer,
}) => ({
  email: loginReducer.email,
  menuArrowToggle: navigationReducer.menuArrowToggle,
  sparkleCardData: analyticalReducer.sparkleCardData,
  loadingPage: analyticalReducer.loadingPage,
});

export default connect(mapStateToProps, {
  toggleMenuArrow,
  loadSparcleCard,
})(Dashbord);
